import { useRef, useState } from "react";
import { setValue } from "../modules/Utils";
import { useI18n } from "Hooks";
import { isRecurringSchoolCalendarEventActionsEnabled } from "../../../modules/Utils";

const useDeleteRecurrance = ({ updateEventModalV2, isRepeatEvent }) => {
  const { t } = useI18n(["common", "calendar"]);
  const repeatEventModalActionRef = useRef({});

  const showNewConfirmationModal =
    isRepeatEvent && isRecurringSchoolCalendarEventActionsEnabled();

  const setRepeatScope = setValue("repeatScope", updateEventModalV2);

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const clickHandler = () => {
    if (isRepeatEvent) {
      repeatEventModalActionRef.current?.open?.();
      return;
    }
    setIsConfirmationModalOpen(true);
  };

  const onSaveRecurrenceHandler = value => {
    setIsConfirmationModalOpen(true);
    repeatEventModalActionRef.current?.close?.();
    setRepeatScope(value);
  };

  const onCloseConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  const handleBackToEditClick = () => {
    setIsConfirmationModalOpen(false);
    if (isRepeatEvent) {
      repeatEventModalActionRef.current?.open?.();
    } else {
      // show the confirmation modal only if the current event is a repeat event
      setIsConfirmationModalOpen(true);
    }
  };

  return {
    clickHandler,
    isConfirmationModalOpen,
    onCloseConfirmationModal,
    handleBackToEditClick,
    onSaveRecurrenceHandler,
    repeatEventModalActionRef,
    setRepeatScope,
    t,
    setIsConfirmationModalOpen,
    showNewConfirmationModal,
  };
};

export default useDeleteRecurrance;
